import * as actions from './actions'

const catalogMunicipalitiesModule = {
    namespaced: true,
    actions,
}

export default catalogMunicipalitiesModule
